var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "web_google_welcome" }, [
    _c("div", { staticClass: "web_google_welcome_text" }, [
      _vm._v(_vm._s(_vm.$t("language.imageSaver.webGoogleBlankText")))
    ]),
    _vm._v(" "),
    _c("img", {
      attrs: {
        draggable: "false",
        src: require("../../assets/images/imageSaver/web_google_welcome.png")
      }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63aa5d3f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63aa5d3f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/image_saver_web_google_welcome.vue
// module id = null
// module chunks = 